import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { loaiChungChiApi } from "../../../api/category/loaiChungChiApi";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { rootActions } from "../../actions/rootActions";
import { eLoaiChungChiActionIds, ILoaiChungChiActionTypes } from "../../action-types/category/ILoaiChungChiActions";
import { ILoaiChungChi } from "../../../model/response/category/ILoaiChungChi";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
const mainAction= rootActions.category.loaiChungChi;

export function* loaiChungChiSaga(): any {
    yield takeLatest(eLoaiChungChiActionIds.LOAD_START, loadWorker);
    yield takeEvery(eLoaiChungChiActionIds.SAVE_START, saveWorker);
    yield takeEvery(eLoaiChungChiActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
    const res = yield call(loaiChungChiApi.SelectAll);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi khi tải Xếp loại học tập"));
    }
}

function* saveWorker(action: ILoaiChungChiActionTypes): any {
    let res;
    const payload = action.payload as ILoaiChungChi;
    if (payload.id_chung_chi > 0) {
        res = yield call(loaiChungChiApi.Update, payload.id_chung_chi, payload);
    } else {
        res = yield call(loaiChungChiApi.Insert, payload);
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi khi lưu Xếp loại học tập"));
    }
}

function* deleteWorker(action: ILoaiChungChiActionTypes): any {
    const id = action.payload as number;
    const res: IBaseResponse = yield call(loaiChungChiApi.Delete, id);
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi khi xóa Xếp loại học tập"));
    }
}